import { getNumericalEntityId } from '@opengov/app-core/entity/selectors';

import { createSelector } from 'reselect';

import { reportFormSelectors } from '../../common/forms/reportForm/state';

import { reportCreateSelector } from '../state';

export const selectReportCreateState = createSelector(reportCreateSelector, (reportCreateState) => reportCreateState);

export const selectNewReport = createSelector(
  [reportCreateSelector, getNumericalEntityId],
  (reportCreateState, numericalEntityId) => reportCreateState.newReport.set('entityId', numericalEntityId)
);

const selectors = reportFormSelectors(reportCreateSelector);

export const selectNewReportFormDescriptionValidationState = selectors.selectReportFormDescriptionValidationState;
export const selectNewReportFormTitleValidationState = selectors.selectReportFormTitleValidationState;
export const selectNewReportFormValidationState = selectors.selectReportFormValidationState;
export const selectNewReportTypeState = selectors.selectReportFormTypeState;
